module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Regular-Alphabetic.9f795fac.woff";